module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "students-leadership-potential.4800e645.webp" + "?" + Date.now();